import React, { useState, useContext } from "react";
import "./faq.scss";
import { motion, AnimatePresence } from "framer-motion";
import { LanguageContext } from "../LanguageSwitcher/LanguageContext";
import useEntryMotion from "../motion/useEntryMotion";

// Exported so the homepage can emit FAQPage structured data from the same
// source the component renders — one list, no chance of the two drifting.
export const faqQuestions = (translations) => [
  { question: translations.question1, answer: translations.question2 },
  { question: translations.question3, answer: translations.question4 },
  { question: translations.question5, answer: translations.question6 },
  { question: translations.question7, answer: translations.question8 },
  { question: translations.question9, answer: translations.question10 },
  { question: translations.question11, answer: translations.question12 },
  { question: translations.question13, answer: translations.question14 },
  { question: translations.question15, answer: translations.question16 },
  { question: translations.question17, answer: translations.question18 },
];

const FAQ = () => {
  const [openQuestion, setOpenQuestion] = useState(null);
  const animateIn = useEntryMotion('scroll');

  const { translations } = useContext(LanguageContext);


  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  const questions = faqQuestions(translations);

  return (
    <div className="faq">
      {questions.map((item, index) => (
        <motion.div
          key={index}
          className={`faq-item  ${ openQuestion === index ? "open-faq-item" : ""}`}
          initial={animateIn ? { opacity: 0, y: 24 } : false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
        >
          <div
            className="faq-question"
            onClick={() => toggleQuestion(index)}
          >
            <span className="faq-number">{String(index + 1).padStart(2, "0")}</span>
            <span className="faq-question-text">{item.question}</span>
            <span className={`faq-toggle ${openQuestion === index ? "faq-toggle-open" : ""}`}>+</span>
          </div>
          <AnimatePresence initial={false}>
            {openQuestion === index && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                style={{ overflow: "hidden" }}
              >
                <motion.div
                  className="faq-answer"
                  initial={{ y: -8, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: -8, opacity: 0 }}
                  transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                >
                  {item.answer}
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      ))}
    </div>
  );
};

export default FAQ;
